import { Button } from 'components/atoms';
import { MagellanPopups } from 'components/molecules';
import { Form } from 'components/organisms';
import { useParamId } from 'hooks/useParamId';
import middleware from 'middleware';
import { useTranslation } from 'react-i18next';
import { PiPencilSimpleLine } from 'react-icons/pi';
import { useNavigate } from 'react-router-dom';
import { PopupActions } from 'reactjs-popup/dist/types';
import {
  useDeleteSectionTemplate,
  useGetSectionTemplate,
} from 'services/templates/section-template';
import { contractTemplateUtil } from 'utils';
import { onErrorShowToast } from 'utils/service/errorHandler';

const CustomSectionTemplate = () => {
  const id = useParamId('/templates-extended');
  const { t } = useTranslation();
  const navigate = useNavigate();

  const sectionTemplate = useGetSectionTemplate(id);

  const deleteSectionTemplate = useDeleteSectionTemplate(id);

  const onRemoveSectionTemplate = async (actions: PopupActions) => {
    await deleteSectionTemplate.mutateAsync(undefined, {
      onError: error => {
        actions.close();
        onErrorShowToast(error);
      },
      onSuccess: () => navigate('/templates-extended'),
    });
  };

  return (
    <Form.Contract
      tittle={
        sectionTemplate.data?.title ?? t('contract-template.section.title')
      }
      backPath='templates-extended'
      initialStatus={{
        ...contractTemplateUtil.section.initialStatus,
        displayMode: true,
      }}
      onSubmit={() => {}}
      initialValues={{
        ...contractTemplateUtil.form.initialValues,
        items: sectionTemplate.data
          ? middleware.template.section.queryToForm(sectionTemplate.data)
          : contractTemplateUtil.section.initialValues(),
      }}
      topbarContent={
        <div className='flex'>
          <Button
            isClear
            onlyIcon
            onClick={() =>
              navigate(`/templates-extended/section/edit/${id}/form`, {
                replace: true,
              })
            }>
            <Button.Description description={t('button.edit')} />

            <Button.Icon icon={<PiPencilSimpleLine />} />
          </Button>
          <MagellanPopups.DeleteWarning
            onRemove={onRemoveSectionTemplate}
            removeLoading={deleteSectionTemplate.isPending}
            name={sectionTemplate.data?.title}
          />
        </div>
      }
    />
  );
};

export default CustomSectionTemplate;
